import BreacrumbsTooltip from './BreadcrumbsTooltip';

export default BreacrumbsTooltip;
